import type { ReactNode } from "react";
import {
  PageContainer,
  PageHeader,
  PageMainCard,
} from "@volca/ui/components/ui/page-components";
import { Spinner } from "@volca/ui/components/ui/spinner";

export const SettingsPageLoading = ({ title }: { title: ReactNode }) => (
  <PageContainer variant="workspace" aria-busy="true">
    <PageHeader title={title} />
    <PageMainCard>
      <Spinner layout="centered" aria-label={`Loading ${title}`} />
    </PageMainCard>
  </PageContainer>
);
